/** Module picker shown when object creation needs a target module disambiguated. */
export function ModuleSelectionButtons({
  modules,
  onSelect,
  onCancel,
}: {
  modules: Array<{ id: string; label: string }>;
  onSelect: (moduleId: string, moduleLabel: string) => void;
  onCancel: () => void;
}) {
  return (
    <div className="module-selection-buttons">
      {modules.map((mod) => (
        <button
          key={mod.id}
          type="button"
          className="module-selection-btn"
          onClick={() => onSelect(mod.id, mod.label)}
        >
          {mod.label}
        </button>
      ))}
      <button
        type="button"
        className="module-selection-btn module-selection-cancel"
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}
